import { render, staticRenderFns } from "./NewApplicants.vue?vue&type=template&id=28ab96ea&"
import script from "./NewApplicants.vue?vue&type=script&lang=js&"
export * from "./NewApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports